<template>
  <div class="boosts-wrapper">
    <div class="buttons-panel-text">
      <span>
        {{ getText() }}
      </span>
    </div>
    <div
      class="buttons-div"
    >
      <div class="buttons-wrapper">
        <GenericButton
          v-for="boost in Object.keys(Boosts)"
          :key="boost"
          :title="state.build.Boosts[boost].tagged ? 'Boosted ' + state.build.Boosts[boost].name + ' +10%' : state.build.Boosts[boost].available ? 'Boost ' + state.build.Boosts[boost].name : state.build.Boosts[boost].name + ' boost is no longer available'"
          @click="tagBoost(boost)"
          :image-src="getBoostImage(boost)"
          :is-active="state.build.Boosts[boost].tagged"
          :is-disabled="!state.build.Boosts[boost].available"
          image-width="40px"
        />
      </div>
    </div>
    <div class="marshal-div">
      <img
        class="image-marshal"
        src="@/assets/img/boosts/marshal.gif"
        alt=""
      >
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import GenericButton from "../shared/GenericButton.vue";
export default {
    name: "Boosts",
    setup() {
        const store = useStore();
        const marshalBoostTagged = () => {
            return store.state.build.info.marshalBoost;
        };
        const getText = () => {
            const boosts = Object.keys(store.state.build.Boosts);
            let text = "Marshal's boost!";
            boosts.forEach((boost) => {
                if (store.state.build.Boosts[boost].tagged) {
                    text = `${store.state.build.Boosts[boost].name} +10%`;
                }
            });
            return text;
        };
        const getBoostImage = (boost) => {
            return require(`@/assets/img/boosts/${boost}.png`);
        };
        const tagBoost = (boost) => {
            const data = {
                skill: boost,
                modifier: "boost",
                multiplier: 1,
            };
            store.dispatch('handleIncomingCommand', {
                command: 'modifySkill',
                data: data
            });
        };
        return {
            state: store.state,
            Boosts: store.state.build.Boosts,
            marshalBoostTagged,
            getText,
            getBoostImage,
            tagBoost,
        };
    },
    components: { GenericButton }
};
</script>
<style scoped>
.boosts-wrapper {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.buttons-div {
  display: inline-block;
  width: 75%;
}
.buttons-wrapper {
  cursor: default;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 4px;
  margin-top: 4px;
}
.marshal-div {
  display: inline-block;
  width: 20%;
}
.image-marshal {
  width: 70%;
}
.buttons-panel-text {
  position: absolute;
  bottom: 15px;
  right: 5px;
  width: 38%;
  font-size: 12px;
  text-shadow: 1px 1px rgb(48, 41, 41);
  max-height: 12px;
  color: antiquewhite;
}
</style>